export const ruimtelijkePlannenConfig = {
  documentBaseUrl: 'https://www.ruimtelijkeplannen.nl/documents',
  mapBaseUrl: 'https://www.ruimtelijkeplannen.nl/view?planidn=',
}
